import React from 'react';
import PropTypes from 'prop-types';
import { formatMoney } from '@shopify/theme-currency';

import { imageUrl } from '../../../../scripts/utils/shopify-images';

const CartItem = ({ item, updateLineItems }) => (
  <tr>
    {item?.featured_image?.url && (
      <td className="text-left pr-img-td" data-label={window.theme.strings.cartTableHeaderProduct}>
        <a href={item.url}>
          <img
            src={imageUrl(item.featured_image.url, 180, 270, 'center')}
            width={180}
            height={270}
            alt={item.title}
            className="component-image__image cart__image"
            loading="lazy"
          />
        </a>
      </td>
    )}
    <td className="text-left product-name-td">
      <h5 className="product-name">
        <a href={item.url}>{item.product_title}</a>
        <span className="saso-cart-item-discount-notes" data-key={item.key}></span>
        <span className="saso-cart-item-upsell-notes" data-key={item.key}></span>

        {!item.product_has_only_default_variant &&
          item.options_with_values.map((option) => (
            <div className="cart__meta-text" key={`${item.id}-${option.value}`}>
              {option.name}: {option.value}<br />
            </div>
          ))}
      </h5>

      {item.properties && (
        <div className="cart__meta-text">
          {Object.entries(item.properties)
            .filter(([key]) => !key.startsWith('_'))
            .map(([key, value]) => (
              <div key={key}>
                {key}: {value}
              </div>
            ))}
        </div>
      )}

      <button onClick={() => updateLineItems({ [item.key]: 0 })} className="remove-item btn-none" type="button">{window.theme.strings.remove}</button>
    </td>
    <td data-label={window.theme.strings.cartTableHeaderPrice}>
      <span className="cart-price">
        <span className="money"><span className="saso-cart-item-price" data-key={item.key} dangerouslySetInnerHTML={{ __html: formatMoney(item.price, window.theme.moneyFormat) }} /></span>
      </span>
      {item.line_level_discount_allocations.length > 0 && (
        item.line_level_discount_allocations.map((discount) => (
          <div className="cart-item__discount medium-up--hide" key={discount.discount_application.title}>
            {discount.discount_application.title}
          </div>
        ))
      )}
    </td>
    <td className="a-center product-qty last" data-label={window.theme.strings.cartTableHeaderQty}>
      {item.line_price > 0 && (
        <>
          <button
            onClick={() => updateLineItems({ [item.key]: item.quantity - 1 })}
            className="reduced items"
            type="button"
          >
            -
          </button>
          <input
            id={`cart-qty_${item.key}`}
            type="number"
            name="quantity"
            min="1"
            aria-label={window.theme.strings.itemQuantity}
            value={item.quantity}
            autoComplete="off"
            onBlur={(event) =>
              item.quantity === Number(event.target.value) ? null : updateLineItems({ [item.key]: event.target.value })
            }
          />
          <button
            onClick={() => updateLineItems({ [item.key]: item.quantity + 1 })}
            className="increase items"
            type="button"
          >
            +
          </button>
          <div className="cart-actions">
            <a href={item.url} className="edit-item"><i className="icon-pencil"></i></a>
          </div>
        </>
      )}
    </td>
  </tr>
);

CartItem.propTypes = {
  item: PropTypes.object,
  updateLineItems: PropTypes.func,
};

export default CartItem;
